import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../helpers/firebase-config.js';
import moment from 'moment';
import { apiEndpoint, onlyNumbers } from '../helpers/utils.js';
import { AuditoriaStatus, PermissaoGeral } from '../helpers/enums.js';
import axios from 'axios';

export function setPaciente(data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(data.cpf)
      .set(data)
      .then(() => resolve(true))
      .catch(erro => reject(erro.code));
  });
}

export function updatePaciente(id, data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(id)
      .update(data)
      .then(() => resolve(true))
      .catch(erro => reject(erro.code));
  });
}
export async function saveLogUpdate(data, cpf) {
  await Libfirebase.collection('paciente')
    .doc(cpf)
    .collection('audit')
    .add(data)
    .catch(erro => console.log(erro.code));
}

export async function atualizarEspecialidades() {
  var pacs = await Libfirebase.collection('paciente').get();

  for (let pac of pacs.docs) {

    var especialidadesList = [];

    var historico = await pac.ref.collection('historico').get();
    for (let hist of historico.docs) {
      if (!especialidadesList.includes(hist.data().especialidade))
        especialidadesList.push(hist.data().especialidade)
    }

    pac.ref.update({
      especialidades: especialidadesList
    });

  }
}

export async function atualizarEspecialidadesPaciente(id, especialidade) {

  await Libfirebase
    .collection('paciente')
    .doc(id)
    .get()
    .then(doc => {
      if (doc.exists) {
        let dadosPaciente = doc.data();
        if (dadosPaciente.especialidades && Array.isArray(dadosPaciente.especialidades)) {
          let especialidades = dadosPaciente.especialidades;
          if (!dadosPaciente.especialidades.includes(especialidade)) {
            especialidades.push(especialidade);
            Libfirebase.collection('paciente').doc(id).update({ especialidades });
          }
        } else {
          Libfirebase.collection('paciente').doc(id).update({ especialidades: [especialidade] });
        }
      }
    })
    .catch(erro => console.log(erro))

}

export function getListPacienteAlgolia(
  busca,
  usuario,
  buscaEsp,
  buscaMedico,
  data1,
  data2,
  buscaCidade,
  buscaStatus
) {
  // algolia
  const algoliasearch = require("algoliasearch");
  const client = algoliasearch("S4T1I4OXWN", "01bed30f13ef39976e5b4204eba41be4");
  const index = client.initIndex("paciente");
  let listPaciente = [];
  // console.log("termo", busca)

  let filters = ""
  if (buscaEsp) {
    filters += filters == "" ? `historico.especialidade:${buscaEsp}` : ` AND historico.especialidade:${buscaEsp}`
  }
  if (buscaMedico) {
    filters += filters == "" ? `historico.refProfissional:"${buscaMedico}"` : ` AND historico.refProfissional:"${buscaMedico}"`
  }
  if (data1 && data2) {
    filters += filters == "" ?
      `historico.DataCriacao:${data1.valueOf()} TO ${data2.valueOf()}` :
      ` AND historico.DataCriacao:${data1.valueOf()} TO ${data2.valueOf()}`
  }
  if (buscaCidade) {
    filters += filters == "" ? `cidade:"${buscaCidade}"` : ` AND cidade:"${buscaCidade}"`
  }
  if (buscaStatus) {
    // REGRA ESPECIFICA PARA PACIENTES QUE ESTÃO AGUARDANDO AUDITORIA
    if (buscaStatus.toLowerCase().includes('auditoria')) {
      const auditoriaQuery = `(status_auditoria_material:"${AuditoriaStatus.Aguardando}" OR status_auditoria_material:"${AuditoriaStatus.Comentado}")`
      filters += filters == "" ? auditoriaQuery : ` AND ${auditoriaQuery}`
    } else {
      filters += filters == "" ? `status:"${buscaStatus}"` : ` AND status:"${buscaStatus}"`
    }
  }

  // console.log("termo", busca)
  console.log("filters", filters)

  return new Promise(function (resolve, reject) {
    index
      .search(busca, {
        filters: filters,
        hitsPerPage: 50,
        attributesToHighlight: []
      })
      .then(({ hits }) => {
        console.log(hits);
        hits.forEach((h) => {
          console.log("usuario.permissao", usuario.permissao)

          if ((!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined')
            && usuario.permissao.toString() === PermissaoGeral.Enfermeiro) {
            let data = {
              ref: Libfirebase.doc(h.path),
              id: h.objectID,
              paciente: h
            };

            listPaciente.push(data)
          } else {
            let pode = true;
            if ((!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined') &&
              [PermissaoGeral.Regulação, PermissaoGeral.Secretário].includes(usuario.permissao.toString())
              && usuario.Cidade) {
              pode = h.cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase() === usuario.Cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
            }
            if (pode) {
              let data = {
                ref: Libfirebase.doc(h.path),
                id: h.objectID,
                paciente: h
              };

              listPaciente.push(data)
            }
          }


          // let data = {
          //   ref: Libfirebase.doc(h.path),
          //   id: h.objectID,
          //   paciente: h
          // };

          // listPaciente.push(data)
        })

        resolve(listPaciente);
      })
      .catch(err => {
        console.log(err);
        reject(err)
      });
  });
}


export function getListPaciente(usuario) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente');

    console.log("lista de pacientes")
    if (!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined') {
      if (usuario.permissao.toString() === PermissaoGeral.Enfermeiro ||
        usuario.permissao.toString() === PermissaoGeral.Paciente) {
        ref = ref.where('idUsuario', '==', usuario.id);
      }
      // if(usuario.permissao.toString() === PermissaoGeral.Secretário){
      //   ref = ref.where('cidade', '==', usuario.Cidade);
      // }
    }
    if (usuario.samu) {
      ref = ref.where('samu', '!=', '');
    }
    // else if (usuario.permissao.toString() === '1') {
    //   ref.where('hospital', '==', usuario.hospital);
    // }
    // console.log(ref)

    ref
      .get()
      .then(snapShot => {
        let listPaciente = [];
        snapShot.forEach(doc => {
          let data = [];
          // if (doc.data().status !== 'Finalizado') {
          if ((!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined')
            && usuario.permissao.toString() === PermissaoGeral.Enfermeiro) {

            if ((!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined') && doc.data().idUsuario === usuario.id) {
              data = {
                ref: doc.ref,
                id: doc.id,
                paciente: doc.data()
              };

              listPaciente.push(data);
            } else {
              data = {
                ref: doc.ref,
                id: doc.id,
                paciente: doc.data()
              };

              listPaciente.push(data);
            }
          } else {
            // if (usuario.permissao.toString() === '1') {
            //   if (doc.data().hospital === usuario.hospital) {
            //     data = {
            //       ref: doc.ref,
            //       id: doc.id,
            //       paciente: doc.data()
            //     };

            //     listPaciente.push(data);
            //   }
            // }
            // else {
            let pode = true;
            if ((!usuario.samu || usuario.samu == null || typeof usuario.samu == 'undefined') &&
              [PermissaoGeral.Regulação, PermissaoGeral.Secretário].includes(usuario.permissao.toString())
              && usuario.Cidade) {
              pode = doc.data().cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase() === usuario.Cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
            }
            if (pode) {
              data = {
                ref: doc.ref,
                id: doc.id,
                paciente: doc.data()
              };
              listPaciente.push(data);
            }
          }
          // }
          // } 
        });
        console.log("listPaciente.length", listPaciente.length)
        resolve(listPaciente);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getPaciente(id) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(id)
      .get()
      .then(snapShot => {
        if (snapShot.exists) {
          let data = {
            id: snapShot.id,
            ref: snapShot.ref,
            paciente: snapShot.data()
          };
          resolve(data);
        }
      })
      .catch(erro => reject(erro.code));
  });
}

export function getPacientesWithStatus() {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente').where('status', "!=", "").get()
      .then(snapShot => {
        let listPaciente = [];
        snapShot.forEach(doc => {
          let data = {
            ref: doc.ref,
            id: doc.id,
            paciente: doc.data()
          };
          listPaciente.push(data);
        });
        resolve(listPaciente);
      })
      .catch(erro => reject(erro.code));
  });
}

export function setHistorico(data, id, midias) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(id)
      .update({ status: 'Aguardando Análise' });

    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('historico');

    ref
      .add(data)
      .then(snap => {
        // resolve(true)

        if (midias.length !== 0) {
          midias.forEach(item => {
            ref
              .doc(snap.id)
              .collection('Midias')
              .add({ url: item, data: moment().add(3, "hours").format("YYYY-MM-DD HH:mm:ss") });
          });
        }

        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}


export function setSolicitaExame(data, id_paciente, id_sol) {
  return new Promise(function (resolve, reject) {
    let ref = null;

    if (id_sol != '') {
      ref = Libfirebase.collection('paciente')
        .doc(id_paciente)
        .collection('solicitacao_exames').doc(id_sol);
    } else {
      Libfirebase.collection('paciente')
        .doc(id_paciente)
        .collection('solicitacao_exames').doc();
    }

    ref
      .set(data)
      .then(snap => {
        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getSolicitacaoExames(id_paciente) {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection('paciente').doc(id_paciente).collection("solicitacao_exames").get().then(async (exs) => {
      resolve(exs.docs.map(item => { return { id: item.id, ref: item.ref, ...item.data() } }));
    });
  });
}

export function getMensagens(id_paciente) {
  return new Promise(async function (resolve, reject) {
    resolve(
      Libfirebase.collection('conversas').where('users', 'array-contains', id_paciente)
    );
  });
}

export function getAuditorias(id_paciente) {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection('paciente').doc(id_paciente).collection("auditoria_material").get().then(async (exs) => {
      resolve(exs.docs.map(item => { return { id: item.id, ref: item.ref, ...item.data() } }));
    });
  });
}

export function setExame(data, id, midias) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('exames');

    ref
      .add(data)
      .then(snap => {
        // resolve(true)

        if (midias.length !== 0) {
          midias.forEach(item => {
            ref
              .doc(snap.id)
              .collection('Midias')
              .add({ url: item });
          });
        }

        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}

export function updateExame(data, id, midias, idExame, listExistent) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('exames')
      .doc(idExame);

    ref
      .update(data)
      .then(async () => {
        // resolve(true)

        if (midias.length !== 0) {
          await midias.forEach(item => {
            let resultado = listExistent.findIndex(x => x.midia.url === item);

            if (resultado < 0) {
              ref.collection('Midias').add({ url: item });
            }
          });
        }
        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getExame(id, idExame) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(id)
      .collection('exames')
      .doc(idExame)
      .get()
      .then(snap => {
        if (snap.exists) {
          resolve(snap.data());
        } else {
          reject('Não foi encontrado o exame');
        }
      })
      .catch(error => reject(error.code));
  });
}

export async function getListHistorico(id, usuario) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('historico');

    // if (usuario.permissao.toString() !== '0') {
    //   ref.where('especialidade', '==', usuario.especialidade);
    // }

    resolve(ref)

  });
}

export function getListExame(id) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(id)
      .collection('exames')
      .orderBy('DataCriacao')
      .get()
      .then(async snap => {
        let listExames = [];

        await snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            exame: item,
            profissional: ''
          };

          listExames.push(data);
        });

        resolve(listExames);
      })
      .catch(error => reject(error.code));
  });
}

export function getListMidia(id, idPaciente) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('paciente')
      .doc(idPaciente)
      .collection('historico')
      .doc(id)
      .collection('Midias')
      .get()
      .then(snap => {
        let listMidia = [];
        snap.forEach(doc => {
          if (doc.exists) {
            let data = {
              id: doc.id,
              midia: doc.data()
            };

            listMidia.push(data);
          }
        });
        resolve(listMidia);
      })
      .catch(error => reject(error.code));
  });
}

export function setAtestado(data, id) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('atestado');

    ref
      .add(data)
      .then(snap => {
        resolve(snap);
      })
      .catch(erro => reject(erro.code));
  });
}

export function setReceita(data, id) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('receita');

    ref
      .add(data)
      .then(snap => {
        resolve(snap);
      })
      .catch(erro => reject(erro.code));
  });
}


export function setReceituario(data, id) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('receituario');

    ref
      .add(data)
      .then(snap => {
        resolve(snap);
      })
      .catch(erro => reject(erro.code));
  });
}

export function setAuditoriaMaterial(data, id) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('auditoria_material');

    ref
      .add(data)
      .then(snap => {
        resolve(snap);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getListAtestado(id, idAtestado = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('atestado');

    ref

      .orderBy('DataCriacao')
      .get()
      .then(snap => {
        let listAtestado = [];

        snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            atestado: item,
            profissional: ''
          };

          listAtestado.push(data);
        });
        resolve(listAtestado);
      })
      .catch(error => reject(error.code));
  });
}

export function getListReceita(id, idReceita = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('receita');

    ref

      .orderBy('DataCriacao')
      .get()
      .then(snap => {
        let listReceita = [];

        snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            receita: item,
            profissional: ''
          };

          listReceita.push(data);
        });
        resolve(listReceita);
      })
      .catch(error => reject(error.code));
  });
}

export function getListReceituario(id, idReceita = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('receituario');

    ref.orderBy('DataCriacao')
      .get()
      .then(snap => {
        let listReceituario = [];

        snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            receituario: item,
            profissional: ''
          };

          listReceituario.push(data);
        });
        resolve(listReceituario);
      })
      .catch(error => reject(error.code));
  });
}

export function getListRiscoCirurgico(id, idRiscoCirurgico = null) {
  return new Promise(function (resolve, reject) {

    let ref = Libfirebase.collection('paciente')
      .doc(id)
      .collection('cadastroCirurgico');

    ref

      .orderBy('DataCriacao')
      .get()
      .then(snap => {
        let listRiscoCirurgico = [];

        snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            cadastroCirurgico: item,
            profissional: ''
          };
          listRiscoCirurgico.push(data);
        });
        resolve(listRiscoCirurgico);
      })
      .catch(error => reject(error.code));
  });
}

// -------- itinerarios --------
export async function getPacientes(cidade, limit = 20) {
  try {
    const query = await Libfirebase.collection('paciente')
      .where("cidade", "==", cidade)
      .limit(limit)
      .get()

    let result = query.docs.map(
      doc => { return { id: doc.id, ref: doc.ref, ...doc.data() } }
    )
    return result;
  } catch (error) {
    return null
  }
}

export async function getPacientesDebounce(text, limit = 20) {
  try {
    if (text) {
      const resValue = onlyNumbers(text);
      const isCpf = resValue.length > 0;

      if (isCpf) {
        // precisa formatar o cpf para localizar no banco     
        const query = await Libfirebase
          .collection('paciente')
          .where('cpf', "==", text)
          .limit(limit)
          .get()
        let result = query.docs.map(
          doc => { return { id: doc.id, ref: doc.ref, paciente: doc.data() } }
        )
        return result

      } else {
        const query = await Libfirebase
          .collection('paciente')
          .where('nome', ">=", text)
          .where('nome', "<=", text + 'z')
          .limit(limit)
          .get()

        let result = query.docs.map(
          doc => { return { id: doc.id, ref: doc.ref, paciente: doc.data() } }
        )
        return result
      }
    } else {
      const query = await Libfirebase
        .collection('paciente')
        .limit(limit)
        .get()

      let result = query.docs.map(
        doc => { return { id: doc.id, ref: doc.ref, paciente: doc.data() } }
      )
      return result
    }

  } catch (error) {
    return null
  }
}

export async function getPacienteAnexos(id) {
  try {
    // ATENÇÃO
    // DECIDI COLOCAR transporte_anexos, POIS É ATRELADO A PARTE DE TRANSPORTES
    // PARA NÃO CONFUNDIR COM A PARTE DE CONSULTAS E EXAMES DA TELEMEDICINA
    const query = await Libfirebase.collection('paciente')
      .doc(id)
      .collection('transporte_anexos')
      .get()

    let result = query.docs.map(
      doc => { return { id: doc.id, ref: doc.ref, ...doc.data() } }
    )
    return result;
  } catch (error) {
    return null
  }
}

export async function getAnexosFromDate(dateIni, dateFim) {
  try {
    // ATENÇÃO
    // DECIDI COLOCAR transporte_anexos, POIS É ATRELADO A PARTE DE TRANSPORTES
    // PARA NÃO CONFUNDIR COM A PARTE DE CONSULTAS E EXAMES DA TELEMEDICINA
    const query = await Libfirebase.collectionGroup('transporte_anexos')
      .where('created_at', '>', dateIni)
      .where('created_at', '<', dateFim)
      .get()

    let result = query.docs.map(
      doc => { return { id: doc.id, ref: doc.ref, ...doc.data() } }
    )
    return result;
  } catch (error) {
    return null
  }
}

const asaasUrl = apiEndpoint()
export async function loginBackend() {
  try {
    const data = {
      "username": "unilabs",
      "password": "unilabs123"
    }
    const result = await axios.post(`${asaasUrl}/auth/login`, data)
    return result.data.access_token
  } catch (error) {
    throw error
  }
}

export async function createAsaasCustomer(token, patientId) {
  const data = {
    "patientId": patientId,
  }
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  try {
    const result = await axios.post(`${asaasUrl}/asaas/customer`, data, config)
    return result.data
  } catch (error) {
    throw error
  }
}

export async function getPatientCredits(token, patientId) {
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  try {
    const result = await axios.get(`${asaasUrl}/patient/credits/${patientId}`, config)
    return result.data
  } catch (error) {
    throw error
  }
}